import type { DeepPartial } from '@luna/utils-ts';

import type { Print } from '../../types/Print';

export const printCZFeatureConfig: DeepPartial<Print> = {
    checkboxes: {
        showDefaultPerformance: true,
        showDefaultPurchasePrice: true,
    },
    columns: {
        hideCapitalGainTax: true,
        hideTotalProfitAndFee: true,
    },
    showAccountInfo: true,
};
